<template>
    <div>
    </div>
</template>

<script>
export default {
  name: 'onboardTeam',
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/views/OnboardTeam.vue